import { orderInformationStyles } from "@insite/content-library/Widgets/OrderApprovalDetails/OrderApprovalDetailsOrderInformation";
import { css } from "styled-components";

orderInformationStyles.orderNumberGridItem = {
    width: [6, 3, 3, 3, 3],
    css: css`
        flex-direction: column;
    `,
};
orderInformationStyles.orderDateGridItem = {
    width: [6, 3, 3, 3, 3],
    css: css`
        flex-direction: column;
    `,
};
orderInformationStyles.poNumberGridItem = {
    width: [6, 3, 3, 3, 3],
    css: css`
        flex-direction: column;
    `,
};
orderInformationStyles.statusGridItem = {
    width: [6, 3, 3, 3, 3],
    css: css`
        flex-direction: column;
    `,
};
